<template>
    <svg xmlns="http://www.w3.org/2000/svg"
        :width="width"
        :height="height"
        viewBox="0 0 20.288 14.153"
        aria-labelledby="genius"
        role="presentation">

    <title>genius</title>
    <g :fill="iconColor">
        <g id="layer_2" data-name="layer 2">
            <g id="layer_1-2" data-name="layer 1">
                <path class="cls-1" d="M9.272,13.959a8.862,8.862,0,0,1-4.03-5.225c-1.279,4.028-3.34,5.015-4.223,5.419L0,12.422a5.042,5.042,0,0,0,2.955-2.151,8.694,8.694,0,0,0,1.3-3.494H1.121V4.966H4.382V2.442H.419V.647h9.635v1.8H5.865c0,1.44-.011,1.893-.011,2.524H9.363V6.777H6.023a9.015,9.015,0,0,0,1.9,3.818,6.684,6.684,0,0,0,2.377,1.7Z"/>
                <path class="cls-1" d="M18.261,4.707l.589.744A.7.7,0,0,1,19,5.742a.121.121,0,0,1-.125.13c-.237.016-.26.032-.328.113a12.7,12.7,0,0,1-1.982,2.426l.1,3.882c.045,1.763-1.6,1.828-2.321,1.86l-.8-2.215a4,4,0,0,0,.939.145c.272,0,.725,0,.713-.776l-.033-1.634a20.684,20.684,0,0,1-3.793,2.474l-.906-1.666A12.1,12.1,0,0,0,15.113,7.7l-.067-2.992H10.573V2.9h4.439L14.943,0l1.393.389c.068.015.329.1.329.291,0,.064-.034.113-.147.226-.136.129-.136.195-.136.242L16.427,2.9h3.861V4.707Zm-1.789,0,.034,1.5a7.741,7.741,0,0,0,.985-1.5Z"/>
            </g>
        </g>
    </g>
    </svg>
</template>

<script>

export default {
  props: {
    width: {
      type: Number,
      default: 18
    },
    height: {
      type: Number,
      default: 18
    },
    iconColor: {
      type: String,
      default: 'gray'
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/icon/Genius.vue